import { Box, Link, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const LinkWrapper = styled(Typography)({
  marginLeft: '8px',
  textAlign: 'center',
})

export const ViewInResCenterWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '4px',
})

export const LinkContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 10,
})

export const StyledLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  textDecoration: 'underline',
  fontSize: '14px',
})

